import { Component } from '@angular/core'

@Component({
  selector: 'flowaccount-business-registration-ads-detail-list',
  templateUrl: './business-registration-ads-detail-list.component.html',
  styleUrl: './business-registration-ads-detail-list.component.scss',
})
export class BusinessRegistrationAdsDetailListComponent {
  public mockContent = [
    {
      title: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.1.TITLE',
      detail: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.1.DETAIL',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.2.TITLE',
      detail: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.2.DETAIL',
    },
    {
      title: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.3.TITLE',
      detail: 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.3.DETAIL',
    },
  ]
}
